import { useEffect, useState } from "react";
import SideNavLayout from "../Sidenav/SideNavLayout";
import CompanyDetails from "./screens/company";
import CaptureGuide from "./screens/captureguide";
import FaceCaptureStep from "./screens/facecapturestep";
import PhotoPreviewScreen from "./screens/previewscreen";
import SubmitSuccessScreen from "./screens/submitstatus";
import api from "../api/api";
import { Backdrop, CircularProgress } from "@mui/material"; 
import ToastMessage from "../utils/muitoast";
import { useSelector } from "react-redux";
import Userdetails from "./screens/userdetails";

const OnBoarding = ({employeeRef='', employee={},cid}) => {
  const [screen, setScreen] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [selectedemployee,setSelectedEmployee]=useState('')
const[companyies,setCompanyies]=useState([])
 const [openToast, setOpenToast] = useState(false); // Toast visibility
  const [toastMessage, setToastMessage] = useState(''); // Message to show in Toast
  const [toastSeverity, setToastSeverity] = useState('error'); 
   const user = useSelector((state) => state.user.userDetails);
  const [photos, setPhotos] = useState({
    Front: null,
    Left: null,
    Right: null,
    Up: null,
    Down: null,
  });
    const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
 setOpenToast(false);
  };

  const [loading, setLoading] = useState(false);
  const [capturedSteps, setCapturedSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [isAppAccess,setIsAppAccess]=useState(false)
  const [email, setEmail] = useState("");
const [mobile, setMobile] = useState("");
const[register,setRegister]=useState(false)
const[gender,setgender]=useState('')
const reset=()=>{
    setSelectedCompany('')
   setCurrentStep(0)
    setCapturedSteps([])
    setSelectedCompany('')
    setEmployeeId('')
    setSelectedCompany('')
    setEmployeeId('')
    setSelectedEmployee('')
    setIsAppAccess(false)
    setEmail('')
    setMobile('')
        setPhotos({
    Front: null,
    Left: null,
    Right: null,
    Up: null,
    Down: null,
  })
    
}
useEffect(() => {
  // ✅ Re-enroll flow
  if (
    employeeRef &&
    employee &&
    Object.keys(employee).length > 0
  ) {
    setSelectedEmployee(employee);
console.log(employee,'employee')
setSelectedCompany({id:cid})
    // ✅ Skip CompanyDetails screen
    setScreen(1);
  }
}, [employeeRef, employee]);

const getCompany=async()=>{
  try {
       setLoading(true);
   const response=await api.get(`/v1/timesheets/company-details`) 
  //  if(response.status==200){
  //   setCompanyies(response?.data||[])
  //  }
   
  if (response.status === 200) {
    const allCompanies = response.data || [];
    let finalCompanies = allCompanies;
  
  
    // ✅ If user is in allowed list, only show their assigned company
    if (user.user_roles?.role== "Supervisor") {
   
      const matchedCompany = allCompanies.find(
        c => c.id == user?.user_info?.company_id
      );
      finalCompanies = matchedCompany ? [matchedCompany] : [];
    }
  
    setCompanyies(finalCompanies);
  }
   
   else{
    setCompanyies([])
   }
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }
}
useEffect(()=>{
getCompany()
},[])
const createuser=async()=>{
  try {
    setRegister(true)
   const response=await  api.get(`/v1/users/${mobile}`)
if(response.status==200){
      setToastMessage("Mobile Already Registered");
      setToastSeverity("error");
      setOpenToast(true);
}else{
  setScreen(1)
}

  } catch (error) {
      setToastMessage("Something went wrong. Please try again.");
    setToastSeverity("error");
    setOpenToast(true);
  }finally{
setRegister(false)
  }
 
     
}
const submit = async () => {
 
  try {
    setLoading(true);

    // Convert photos object into array of base64 strings (skip nulls)
   const photoBase64Array = Object.values(photos)
  .filter(Boolean)
  .map((img) => img.replace(/^data:image\/\w+;base64,/, ""));

 if(isAppAccess){
   let  userData = {
          firstname: selectedemployee?.firstname,
          lastname:selectedemployee?.lastname,
      gender:gender,
   "countrycode": "+1",
          phone: mobile,
          email: email,        
          status:'A',
          role: 4,

         user_info: { company_id: selectedCompany?.id ,   "permissions": [
     'A1'
    ]} 
        }
        const usercreation = await api.post('/v1/users', userData);
 }
 let  payload={
      employee_details: {
        empid: selectedemployee?.empid || "",
        firstname: selectedemployee?.firstname || "",
        lastname: selectedemployee?.lastname || "",
        middleini: selectedemployee?.middleini || "",
        classification: selectedemployee?.classification || null,
        phone: selectedemployee?.phone || "",
        city: selectedemployee?.city || "",
        state: selectedemployee?.state || "",
        zipcode: selectedemployee?.zipcode || "",
        status: selectedemployee?.status || null,
        payrate: selectedemployee?.payrate || "0.00",
        salary: selectedemployee?.salary || "0.00",
       company_id: selectedCompany?.id ? String(selectedCompany.id) : null,
 supervisorid:user?.phone||0
      },
      employee_images: photoBase64Array,
      created_by: user?.username

    }
    if(employeeRef){
      payload.rowid=employeeRef
    }
    const response = await api.post(`/v1/onboarding-employee`, payload);

    if (response.status === 200 || response.status === 201) {
      setToastMessage("Employee onboarded successfully!");
      setToastSeverity("success");
      setOpenToast(true);
      reset()
      setScreen(4); // go to success screen
    } else {
      setToastMessage(response?.message||"Failed to onboard employee. Please try again.");
      setToastSeverity("error");
      setOpenToast(true);
    }
  } catch (error) {
    console.error("Onboarding error:", error);
    setToastMessage("Something went wrong. Please try again.");
    setToastSeverity("error");
    setOpenToast(true);
  } finally {
    setLoading(false);
    //  window.location.reload();
  }
};

  const renderScreen = () => {
    switch (screen) {
      case 0:
        return (
          <CompanyDetails
          setSelectedEmployee={setSelectedEmployee}
          selectedemployee={selectedemployee}
          companylist={companyies}
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            employeeId={employeeId}
            setEmployeeId={setEmployeeId}
            setScreen={setScreen}
           setToastSeverity={setToastSeverity}
           setOpenToast={setOpenToast}
           setToastMessage={setToastMessage}
           isAppAccess={isAppAccess}
           setIsAppAccess={setIsAppAccess}
          />
        );
      case 1:
        return (
          <CaptureGuide
            selectedCompany={selectedCompany}
            employee={selectedemployee}
            setScreen={setScreen}
          />
        );
      case 2:
        return (
          <FaceCaptureStep
            key={JSON.stringify(photos)}
            selectedCompany={selectedCompany}
             employee={selectedemployee}
            setScreen={setScreen}
            photos={photos}
            setPhotos={setPhotos}
            capturedSteps={capturedSteps}
            setCapturedSteps={setCapturedSteps}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
        );
       case 3:
  return (
    <PhotoPreviewScreen
     selectedCompany={selectedCompany}
    submit={submit}
     setPhotos={setPhotos} 
      photos={photos}
      setScreen={setScreen}
      setCurrentStep={setCurrentStep}
      setCapturedSteps={setCapturedSteps}
      reset={reset}
          employee={selectedemployee}
    />
  ); 
  case 4:
  return (
    <SubmitSuccessScreen
      setScreen={setScreen}
  employee={selectedemployee}
    />
  );
   case 5:
  return (
 <Userdetails
    selectedCompany={selectedCompany}
            employee={selectedemployee}
            setScreen={setScreen}
            register={register}
              email={email}
  setEmail={setEmail}
  mobile={mobile}
  setMobile={setMobile}
gender={gender}
setgender={setgender}
  createuser={createuser}
 
 />
  );
      default:
        return <div>No screen found</div>;
    }
  };

  return (
       <div className="h-full overflow-auto custom-scrollbar">
      <SideNavLayout>
        <div className="flex justify-center items-center min-h-[80vh] w-full">
          {renderScreen()}
        </div>
      </SideNavLayout>
<ToastMessage
        message={toastMessage} 
        severity={toastSeverity} 
        open={openToast} 
        handleClose={handleCloseToast} 
      />
        
     
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default OnBoarding;